import styled from '@emotion/styled';

export const Container = styled.div`
	${({ invisible }) => invisible && 'display: none;'}
	overflow: ${({ animate }) => (animate ? 'hidden' : 'auto')};
	width: 100%;
`;
